import * as types from './types';

/**
 * Builds the action to dispatch for fetching invoice templates.
 * @param {object} payload
 * @param {number} payload.orgId - The id of the org to get the templates from.
 * @returns {object} - the action to dispatch.
 */
export const getInvoiceTemplates = (payload) => {
  return {
    type: types.GET_INVOICE_TEMPLATES,
    payload,
  };
};
